import { TableColumnsType } from 'antd';
import { TFunction } from 'i18next';
import { IGoogleMerchantSyncRun } from '@/models/googleMerchantSync.model';
import { renderDate } from '@/utils';
import { DateFormats } from '@/constants/dates';
import { GoogleMerchantSyncErrorSummary } from '../components';

export const getGoogleMerchantSyncTableColumns = (t: TFunction): TableColumnsType<IGoogleMerchantSyncRun> => [
  {
    title: t('label_status'),
    dataIndex: 'status',
    key: 'status',
    render: (status: string) => status,
  },
  {
    title: t('label_mode'),
    dataIndex: 'mode',
    key: 'mode',
    render: (mode: number) => mode,
  },
  {
    title: t('label_start_date'),
    dataIndex: 'startedAt',
    key: 'startedAt',
    render: (startedAt?: string) => (startedAt ? renderDate(startedAt, DateFormats.DATE_WITH_TIME) : '-'),
  },
  {
    title: t('label_finish_date'),
    dataIndex: 'finishedAt',
    key: 'finishedAt',
    render: (finishedAt?: string) => (finishedAt ? renderDate(finishedAt, DateFormats.DATE_WITH_TIME) : '-'),
  },
  {
    title: t('label_processed_count'),
    dataIndex: 'processedCount',
    key: 'processedCount',
    render: (value?: number) => value ?? 0,
  },
  {
    title: t('label_success_count'),
    dataIndex: 'successCount',
    key: 'successCount',
    render: (value?: number) => value ?? 0,
  },
  {
    title: t('label_failed_count'),
    dataIndex: 'failedCount',
    key: 'failedCount',
    render: (value?: number) => value ?? 0,
  },
  {
    title: t('label_skipped_count'),
    dataIndex: 'skippedCount',
    key: 'skippedCount',
    render: (value?: number) => value ?? 0,
  },
  {
    title: t('label_delete_success_count'),
    dataIndex: 'deleteSuccessCount',
    key: 'deleteSuccessCount',
    render: (value?: number) => value ?? 0,
  },
  {
    title: t('label_errors'),
    dataIndex: 'errorSummary',
    key: 'errorSummary',
    render: (_, record) => (
      <GoogleMerchantSyncErrorSummary failureCode={record.failureCode} errorSummary={record.errorSummary} />
    ),
  },
];
